import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:dd0a420a-4774-4293-af16-1b7e8d900e56",
    aws_user_pools_id: "eu-west-1_7dfPivdPI",
    aws_user_pools_web_client_id: "6v9s6qdvikmi0gb899uni9kps6",
    Auth: {
      identityPoolId: "eu-west-1:dd0a420a-4774-4293-af16-1b7e8d900e56",
      region: "eu-west-1",
      userPoolId: "eu-west-1_7dfPivdPI",
      userPoolWebClientId: "6v9s6qdvikmi0gb899uni9kps6",
    },
    oauth: {
      domain: "whs-safer-beta-eu.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://beta.eu.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.eu.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve beta to "test".
  const stage = "beta".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
